export default __webpack_public_path__ + "static/media/I0005.76d3609b.png";